import script from "./ServiceWorkerUpdatePopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServiceWorkerUpdatePopup.vue?vue&type=script&setup=true&lang=ts"

import "./ServiceWorkerUpdatePopup.vue?vue&type=style&index=0&id=3d539660&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d539660"]])

export default __exports__